<template>
  <div>
    <a-button class="bg-black" @click="PublishScan()" type="primary">PublishScan</a-button>
    <a-button @click="PublishDiagnose()" type="primary">PublishDiagnose</a-button>
    <a-button @click="PublishProperties()" type="primary">PublishProperties</a-button>
    <a-button @click="TestAlarm()" type="primary">alarm</a-button>
    <a-button @click="TestAlarm()" type="primary">alarm</a-button>

     <div v-if="qrCodeDataUrl">
      <img :src="qrCodeDataUrl" alt="QR Code" />
    </div>

  </div>
</template>

<script>
// const iconv = require('iconv-lite')
import QRCode from 'qrcode'
export default {
  name: 'Home',

  data () {
    return {
      selectedFile: null,
      text: 'ksdjlkasjdlkjgkasdlakjer623', // 用來保存用戶輸入的字串
      qrCodeDataUrl: '' // 用來保存生成的 QR code 的 Data URL
    }
  },
  computed: {
    mqttClient: {
      get () {
        return this.$store.state.mqttClient
      },
      set () {}
    }
  },
  mounted () {
    this.generateQRCode()
  },
  methods: {
    async generateQRCode () {
      try {
        // 使用 qrcode 庫將字串轉換為 QR code Data URL
        this.qrCodeDataUrl = await QRCode.toDataURL(this.text)
      } catch (error) {
        console.error('生成 QR Code 時發生錯誤', error)
      }
    },
    PublishScan () {
      const inf = JSON.stringify({})
      // eslint-disable-next-line no-undef
      const message = new Paho.MQTT.Message(inf)
      message.destinationName = 'scan'
      this.mqttClient.send(message)
    },
    PublishDiagnose () {
      const inf = JSON.stringify({})
      // eslint-disable-next-line no-undef
      const message = new Paho.MQTT.Message(inf)
      message.destinationName = 'diagnose'
      this.mqttClient.send(message)
    },
    PublishProperties () {
      const inf = JSON.stringify({})
      // eslint-disable-next-line no-undef
      const message = new Paho.MQTT.Message(inf)
      message.destinationName = 'properties'
      this.mqttClient.send(message)
    }
  }
}
</script>

<style lang="css" scoped>
.ota-box {
  border: 3px solid black;
  padding: 15px;
}

/* .ant-btn-primary{
  background-color: red;
} */
</style>
